export const TIMEZONES = [
  // Europe
  { value: 'Europe/Stockholm', label: 'Europe/Stockholm (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Oslo', label: 'Europe/Oslo (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Copenhagen', label: 'Europe/Copenhagen (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Helsinki', label: 'Europe/Helsinki (EET/EEST)', region: 'Europe' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Paris', label: 'Europe/Paris (CET/CEST)', region: 'Europe' },
  { value: 'Europe/London', label: 'Europe/London (GMT/BST)', region: 'Europe' },
  { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Brussels', label: 'Europe/Brussels (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Vienna', label: 'Europe/Vienna (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Zurich', label: 'Europe/Zurich (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Rome', label: 'Europe/Rome (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Madrid', label: 'Europe/Madrid (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Warsaw', label: 'Europe/Warsaw (CET/CEST)', region: 'Europe' },
  { value: 'Europe/Prague', label: 'Europe/Prague (CET/CEST)', region: 'Europe' },
  
  // Americas
  { value: 'America/New_York', label: 'America/New York (EST/EDT)', region: 'Americas' },
  { value: 'America/Chicago', label: 'America/Chicago (CST/CDT)', region: 'Americas' },
  { value: 'America/Denver', label: 'America/Denver (MST/MDT)', region: 'Americas' },
  { value: 'America/Los_Angeles', label: 'America/Los Angeles (PST/PDT)', region: 'Americas' },
  { value: 'America/Toronto', label: 'America/Toronto (EST/EDT)', region: 'Americas' },
  { value: 'America/Vancouver', label: 'America/Vancouver (PST/PDT)', region: 'Americas' },
  { value: 'America/Mexico_City', label: 'America/Mexico City (CST/CDT)', region: 'Americas' },
  { value: 'America/Sao_Paulo', label: 'America/São Paulo (BRT/BRST)', region: 'Americas' },
  
  // Asia/Pacific
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)', region: 'Asia/Pacific' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai (CST)', region: 'Asia/Pacific' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore (SGT)', region: 'Asia/Pacific' },
  { value: 'Asia/Seoul', label: 'Asia/Seoul (KST)', region: 'Asia/Pacific' },
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)', region: 'Asia/Pacific' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney (AEST/AEDT)', region: 'Asia/Pacific' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne (AEST/AEDT)', region: 'Asia/Pacific' },
  
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', region: 'UTC' },
] as const;
